import React from 'react';
import { Box, makeStyles, TableRow, TableCell } from '@material-ui/core';
import BodyText from './BodyText';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
const useStyles = makeStyles(() => ({
	optionsIcon: {
		height: 25,
		width: 25,
		backgroundColor: '#FDE8EE',
		padding: 3,
		borderRadius: '50%',
	},
	tableCell: {
		fontSize: 16,
		// padding: 3,
		fontWeight: 600,
	},
	img: {
		'& .MuiAvatar-img': {
			width: 30,
			height: 30,
		},
	},
}));
const DashboardTable2 = ({ item, rowIndex }) => {
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();

	return (
		<>
			<TableRow key={rowIndex}>
				<TableCell className={classes.tableCell}>ddf</TableCell>
				<TableCell className={classes.tableCell}>df</TableCell>
				<TableCell className={classes.tableCell}>gg</TableCell>
				<TableCell className={classes.tableCell}>gedf</TableCell>
				<TableCell className={classes.tableCell}>gedf</TableCell>
				<TableCell className={classes.tableCell}>gedf</TableCell>
				{/* <TableCell className={classes.tableCell}>gedf</TableCell> */}
			</TableRow>
		</>
	);
};

export default DashboardTable2;
